import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const toneStyles = {
  neutral: { bg: "bg-[#F4F1ED]", color: "text-[#2E4A3B]", accent: "bg-[#2E4A3B]" },
  warning: { bg: "bg-[#FDF6E3]", color: "text-[#8B6518]", accent: "bg-[#D19B34]" },
  info: { bg: "bg-[#EDF5F9]", color: "text-[#2F5A78]", accent: "bg-[#4A7B9D]" },
  success: { bg: "bg-[#E8F3EC]", color: "text-[#2B5A3F]", accent: "bg-[#3B7A57]" },
  danger: { bg: "bg-[#FCEAE8]", color: "text-[#8E3B2A]", accent: "bg-[#C65D47]" },
};

export default function KpiCard({ label, value, icon: Icon, tone = "neutral", subtitle, testid, onClick }) {
  const s = toneStyles[tone];
  const isClickable = typeof onClick === "function";
  const commonProps = {
    "data-testid": testid,
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    whileHover: { y: -2 },
    transition: { duration: 0.2 },
    className: `mag-card p-6 relative overflow-hidden text-left ${
      isClickable ? "cursor-pointer hover:shadow-md focus-visible:ring-2 focus-visible:ring-[#2E4A3B] focus-visible:outline-none" : ""
    }`,
  };

  const inner = (
    <>
      <div className="flex items-start justify-between mb-4">
        <p className="text-xs font-semibold uppercase tracking-[0.1em] text-[#5C5F5A]">
          {label}
        </p>
        {Icon && (
          <div className={`h-9 w-9 rounded-lg ${s.bg} ${s.color} flex items-center justify-center`}>
            <Icon size={18} />
          </div>
        )}
      </div>
      <div className="text-3xl lg:text-4xl font-semibold tracking-tight text-[#1A1C1A]" style={{ fontFamily: "Work Sans, sans-serif" }}>
        {value}
      </div>
      {subtitle && <div className="text-xs text-[#8E918C] mt-2">{subtitle}</div>}
      {isClickable && (
        <div className={`absolute bottom-3 right-3 ${s.color} opacity-0 group-hover:opacity-100 transition-opacity`}>
          <ArrowUpRight size={14} />
        </div>
      )}
    </>
  );

  if (isClickable) {
    return (
      <motion.button type="button" {...commonProps} onClick={onClick}>
        {inner}
      </motion.button>
    );
  }
  return <motion.div {...commonProps}>{inner}</motion.div>;
}
